
import { AxiosError } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { GlobalAlertTypes } from '@momnt-technologies/common-ui/lib/plugins/alerts/types';
import { accountLookup } from '@/api/account';
import { getNonFieldError } from '@/utils/error-handler';
import Alert from '~/components/Alerts/Alert.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import HeaderLogo from '@/components/Layout/HeaderLogo.vue';
import ResponsiveContainer from '@/components/Layout/ResponsiveContainer.vue';
import TextInput from '~/components/Inputs/Text.vue';

function generateMask(mask: string) {
  return {
    showMaskOnHover: false,
    noValuePatching: false,
    autoUnmask: true,
    mask,
  };
}

@Component({
  components: {
    Alert,
    CustomButton,
    HeaderLogo,
    ResponsiveContainer,
    TextInput,
  }
})
export default class CreateAccount extends Vue {
  loanNumber = '';

  ssnLastFour = '';

  loanNumberMask = generateMask('999-999-9999');

  ssnMask = generateMask('9999');

  success = false;

  loading = false;

  errorMessage = '';

  get buttonDisabled() {
    return this.loanNumber.length !== 10 || this.ssnLastFour.length !== 4;
  }

  get hasInputs() {
    return this.loanNumber.length > 0 || this.ssnLastFour.length > 0;
  }

  get emailAddress() {
    return this.$store.getters['Config/getBrandSupportEmail'];
  }

  clearInputs() {
    this.loanNumber = '';
    this.ssnLastFour = '';
  }

  async search() {
    this.loading = true;
    try {
      await accountLookup({
        loan_number: this.loanNumber,
        ssn_last_four: this.ssnLastFour
      });
      this.success = true;
    } catch (e) {
      const error = e as AxiosError;

      if (error.response?.status === 409) {
        this.$alerts.add({
          type: GlobalAlertTypes.WARNING,
          timed: true,
          text: 'An account has already been created. Please login using your credentials.'
        });
        this.$router.push({ name: 'login' });
        return;
      }

      this.errorMessage = getNonFieldError(e);
    } finally {
      this.loading = false;
    }
  }
}
